import { Box, SelectChangeEvent } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';

import { SelectInput } from '@/components/common/select_input/SelectInput';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

function HighestGradeInput() {
  const [highestGradeSelection, setHighestGradeSelection] = useState<number | null>(null);
  const { partnerInfo, intakeLabels, updatePartnerInfo, showErrors } =
    useContext(PartnerIntakeContext);

  const handleHighestGradeChange = useCallback(
    (e: SelectChangeEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const updatedValue = (e.target as HTMLInputElement).value;

      if (updatePartnerInfo && partnerInfo) {
        updatePartnerInfo({
          ...partnerInfo,
          highestGrade: Number(updatedValue),
        });
      }
    },
    [updatePartnerInfo, partnerInfo]
  );

  useEffect(() => {
    if (partnerInfo?.highestGrade != highestGradeSelection) {
      setHighestGradeSelection(
        partnerInfo?.highestGrade !== null && partnerInfo?.highestGrade !== undefined
          ? partnerInfo?.highestGrade
          : null
      );
    }
  }, [highestGradeSelection, partnerInfo?.highestGrade, setHighestGradeSelection]);

  return (
    <Box flexGrow={1}>
      <SelectInput
        label={intakeLabels.highestGrade ?? 'Highest Grade'}
        id='highest-grade-select'
        value={
          highestGradeSelection !== null && highestGradeSelection !== undefined
            ? highestGradeSelection.toString()
            : ''
        }
        required
        hasError={showErrors && highestGradeSelection == null}
        onChange={handleHighestGradeChange}
        selectOptions={[
          { value: '-1', label: 'Pre-K' },
          { value: '0', label: 'Kindergarten' },
          { value: '1', label: '1st' },
          { value: '2', label: '2nd' },
          { value: '3', label: '3rd' },
          { value: '4', label: '4th' },
          { value: '5', label: '5th' },
          { value: '6', label: '6th' },
          { value: '7', label: '7th' },
          { value: '8', label: '8th' },
          { value: '9', label: '9th' },
          { value: '10', label: '10th' },
          { value: '11', label: '11th' },
          { value: '12', label: '12th' },
        ]}
      />
    </Box>
  );
}

export default HighestGradeInput;
